import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchRoomTypes } from '@/renderer/services/accommodationService';

export function useRoomTypes(propertyId: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.accommodation.roomTypes(propertyId ?? ''),
    queryFn: () => fetchRoomTypes(propertyId!),
    enabled: !!propertyId,
    staleTime: 1000 * 60 * 5,
  });
}
